import fetch from 'cross-fetch';
import { resToJson, fetchFormData } from '../../common';
import { getPenguinsData } from '../../helpers';

const ftniPortalEndpoint = getPenguinsData(['view_data', 'ftni_portal_urn']);

const FTNI_ACH_DIRECT_POST_ENDPOINT = ftniPortalEndpoint
  ? ftniPortalEndpoint.replace('CreditCard', 'ACH')
  : '';
const FTNI_CC_DIRECT_POST_ENDPOINT = ftniPortalEndpoint
  ? ftniPortalEndpoint.replace('ACH', 'CreditCard')
  : '';

export function checkRoutingNumber(routingNumber, country) {
  return fetch(`/api/get_bank/?acct=${routingNumber}&cntry=${country}`).then(
    resToJson
  );
}

export function ftniAch(ftni_session_id, params) {
  return fetchFormData(
    `${FTNI_ACH_DIRECT_POST_ENDPOINT}${ftni_session_id}`,
    params
  );
}

export function ftniCreditCard(ftni_session_id, params) {
  return fetchFormData(
    `${FTNI_CC_DIRECT_POST_ENDPOINT}${ftni_session_id}`,
    params
  );
}

export function stripeCreditCard(key, params) {
  const Stripe = window.Stripe;
  Stripe.setPublishableKey(key);
  const payload = {
    number: params.CardNumber,
    cvc: params.CVV,
    exp_month: params.ExpirationMonth,
    exp_year: params.ExpirationYear,
    name: params.NameOnCard,
    address_line1: params.Address1,
    address_line2: params.Address2,
    address_city: params.City,
    address_state: params.State,
    address_zip: params.Zip,
    address_country: params.Country
  };

  const tokenizer = Stripe.card.createToken;
  return [tokenizer, payload];
}

export async function stripeCallback(sessionKey, body) {
  return fetch(`/membership_api/payment/callback/${sessionKey}/`, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(resToJson);
}

export function getContractSigningConfig(sessionKey) {
  return fetch(`/membership_api/sign/${sessionKey}/`).then(resToJson);
}

export function checkPaymentMethodStatus(sessionKey) {
  return fetch(`/membership_api/payment/status/${sessionKey}/`).then(resToJson);
}

export function processPayment(sessionKey) {
  return fetch(`/membership_api/payment/response/${sessionKey}/`).then(
    resToJson
  );
}

export function checkChargePaymentStatus(sessionKey, taskId) {
  return fetch(
    `/membership_api/payment/response/${sessionKey}/${taskId}/`
  ).then(resToJson);
}
